import { Title } from '../List';
import styled from 'styled-components';

export const PaddedTitle = styled(Title)`
  max-width: 100%;
  padding-top: ${({ theme }) => theme.spacing.base.md};
`;

export const Unformatted = styled.div`
  max-width: 100%;
  white-space: pre-line;
`;
